/**
 * Mark.jsx — the D'leaps leap-mark.
 *
 * Traced from the studio's own Asset_1.png: every path here is the outline of
 * that artwork, not a redraw. The blob and the apostrophe are the filled
 * shapes; the two teal lines are the sketch strokes, kept as STROKES rather
 * than as the thin filled ribbons a naive trace produces, so the mark stays
 * legible at 20px where a 1px ribbon disappears.
 *
 *   <Mark size={28} />        the bare mark
 *   <Mark size={20} plain />  without the sketch lines, for very small sizes
 *   <MarkDisc size={44} />    on a white disc inside the brand ring
 *
 * The mark is turquoise on transparent. Dropped straight onto the mauve
 * gradient it half-disappears, which is the whole reason MarkDisc exists.
 */

const BLOB = "M172.4 78.1C161.3 78.8 150.2 80.4 139.9 83.5C129.5 86.6 117.8 89.7 110.5 96.6C103.2 103.5 97.7 114.8 96.0 125.0C94.4 135.2 98.3 147.2 100.7 157.8C103.0 168.5 107.3 178.3 110.2 188.6C113.1 199.0 115.9 209.5 117.9 220.2C119.9 231.0 120.9 242.1 122.3 253.1C123.7 264.2 126.2 275.5 126.1 286.3C126.0 297.1 123.5 307.3 121.5 317.8C119.4 328.3 116.4 338.8 113.9 349.4C111.3 359.9 108.8 370.4 106.1 380.9C103.4 391.3 99.6 401.5 97.6 412.1C95.5 422.7 92.0 434.4 93.7 444.6C95.5 454.8 100.9 466.4 108.2 473.4C115.5 480.4 127.0 483.9 137.5 486.5C148.0 489.1 160.0 489.1 171.2 489.0C182.4 488.9 193.9 487.7 204.7 485.9C215.5 484.1 226.0 481.5 236.2 478.2C246.4 474.9 256.3 470.7 265.9 465.9C275.5 461.0 284.8 455.5 293.8 449.3C302.8 443.1 311.5 436.0 319.9 428.5C328.3 421.0 336.9 412.8 344.3 404.3C351.6 395.9 358.3 387.0 363.8 377.7C369.4 368.4 373.9 358.7 377.4 348.6C381.0 338.5 383.4 327.9 385.1 317.0C386.8 306.1 387.6 294.4 387.4 283.2C387.3 272.0 386.3 260.5 384.3 249.8C382.4 239.0 379.5 228.6 375.9 218.5C372.2 208.5 367.5 198.8 362.3 189.4C357.1 180.0 351.5 170.7 344.8 161.9C338.0 153.1 330.0 144.3 321.9 136.7C313.7 129.0 304.7 122.2 295.7 115.9C286.7 109.6 277.5 103.8 268.0 99.0C258.4 94.1 248.6 89.8 238.3 86.6C228.1 83.4 217.5 81.1 206.5 79.7C195.5 78.3 183.5 77.5 172.4 78.1Z";
const SKETCH_A = "M175.4 71.2C163.0 72.2 149.6 72.7 138.8 77.8C128.0 82.8 115.9 91.4 110.9 101.5C105.8 111.6 107.3 126.1 108.3 138.2C109.4 150.3 114.5 162.0 117.2 174.1C120.0 186.1 122.9 198.0 125.0 210.3C127.0 222.5 129.1 235.2 129.6 247.4C130.0 259.6 128.3 271.2 127.7 283.4C127.0 295.7 126.8 308.5 125.7 320.9C124.7 333.3 122.8 345.7 121.4 358.1C120.1 370.4 119.2 382.7 117.6 395.0C116.1 407.3 112.0 419.9 112.2 432.0C112.3 444.2 113.1 458.1 118.6 468.0C124.2 477.9 134.9 486.8 145.5 491.2C156.2 495.5 170.4 494.4 182.8 494.0C195.2 493.6 207.8 491.4 219.8 488.8C231.9 486.1 243.8 482.5 255.3 477.9C266.7 473.3 277.9 467.6 288.4 461.1C299.0 454.6 308.9 446.9 318.5 438.8C328.1 430.8 337.9 422.1 346.1 412.8C354.4 403.4 361.3 393.0 368.0 382.7C374.7 372.3 381.6 362.0 386.3 350.7C391.0 339.4 394.1 327.3 396.2 315.0C398.2 302.8 399.0 289.8 398.6 277.3C398.3 264.9 396.7 252.2 394.0 240.1C391.4 228.1 387.3 216.3 382.4 205.0C377.6 193.6 371.7 182.4 365.0 171.9C358.3 161.4 350.6 151.3 342.2 142.0C333.8 132.7 324.2 123.9 314.4 116.1C304.6 108.3 294.1 101.4 283.3 95.4C272.5 89.3 261.2 84.0 249.6 80.1C237.9 76.1 225.8 73.2 213.4 71.7C201.1 70.2 187.9 70.2 175.4 71.2Z";
const SKETCH_B = "M174.1 78.6C162.0 79.5 148.9 80.1 138.5 85.0C128.0 89.9 116.2 98.2 111.3 108.0C106.4 117.8 107.8 131.9 108.8 143.7C109.9 155.4 114.8 166.9 117.5 178.5C120.2 190.2 123.0 201.9 125.0 213.8C127.0 225.6 129.1 238.0 129.5 249.9C129.9 261.7 128.2 273.0 127.6 284.9C127.0 296.8 126.8 309.2 125.7 321.3C124.7 333.4 122.9 345.4 121.6 357.4C120.3 369.4 119.4 381.3 117.9 393.3C116.4 405.3 112.4 417.5 112.6 429.3C112.7 441.1 113.4 454.7 118.8 464.3C124.2 473.8 134.6 482.6 145.0 486.8C155.4 491.0 169.2 489.9 181.2 489.5C193.2 489.1 205.5 487.1 217.2 484.4C229.0 481.8 240.6 478.4 251.7 473.9C262.8 469.4 273.7 463.9 283.9 457.5C294.1 451.2 303.8 443.7 313.1 435.9C322.5 428.1 332.0 419.7 340.0 410.6C348.0 401.5 354.7 391.4 361.2 381.3C367.7 371.3 374.4 361.2 379.0 350.3C383.6 339.3 386.6 327.5 388.6 315.6C390.6 303.7 391.3 291.1 391.0 278.9C390.6 266.8 389.2 254.5 386.6 242.8C383.9 231.1 380.0 219.6 375.3 208.6C370.5 197.5 364.8 186.7 358.3 176.5C351.8 166.3 344.4 156.4 336.2 147.4C328.0 138.3 318.6 129.8 309.1 122.2C299.6 114.7 289.4 107.9 278.9 102.0C268.4 96.2 257.4 91.0 246.1 87.2C234.8 83.3 223.0 80.5 211.0 79.0C199.0 77.6 186.2 77.6 174.1 78.6Z";
const APOS = "M415.2 18.0C412.8 16.9 407.6 19.5 403.9 20.3C400.1 21.1 395.8 21.4 392.6 22.6C389.4 23.8 385.8 24.7 384.6 27.5C383.3 30.3 384.9 35.5 385.1 39.5C385.3 43.5 385.9 47.5 385.9 51.5C385.9 55.4 385.5 59.5 385.1 63.4C384.7 67.3 384.1 71.2 383.6 75.0C383.1 78.9 382.7 82.8 382.0 86.6C381.4 90.5 380.5 94.2 379.7 98.0C378.9 101.7 376.3 107.1 377.2 109.2C378.1 111.3 382.2 111.6 385.0 110.6C387.8 109.6 391.5 105.9 394.1 103.0C396.7 100.2 398.7 96.7 400.6 93.5C402.6 90.2 404.4 86.8 405.9 83.4C407.5 79.9 408.6 76.3 409.8 72.7C410.9 69.1 412.0 65.4 412.9 61.7C413.8 58.0 414.5 54.2 415.2 50.4C415.8 46.6 416.2 42.7 416.7 38.8C417.2 34.9 418.5 30.6 418.3 27.2C418.0 23.7 417.6 19.1 415.2 18.0Z";

export function Mark({ size = 32, plain = false, title = "D'leaps", className = "" }) {
  return (
    <svg
      className={"mark " + className}
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label={title}
      focusable="false"
    >
      <path d={BLOB} fill="var(--turq, #62E8EF)" />
      {!plain && (
        <g fill="none" strokeLinejoin="round">
          <path d={SKETCH_A} stroke="var(--teal-ink, #2F9696)" strokeWidth="4" />
          <path d={SKETCH_B} stroke="#00948A" strokeWidth="2.8" />
        </g>
      )}
      <path d={APOS} fill="var(--magenta, #E05886)" />
    </svg>
  );
}

/** The mark on a white disc inside the mauve-to-magenta ring. */
export function MarkDisc({ size = 44, ring = true, title = "D'leaps" }) {
  const pad = ring ? Math.max(3, Math.round(size * 0.09)) : 0;
  const inner = Math.round((size - pad * 2) * 0.68);
  return (
    <span
      className="markdisc"
      style={{
        width: size,
        height: size,
        padding: pad,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        flex: "0 0 auto",
        background: ring
          ? "linear-gradient(135deg, var(--mauve, #cf91bf), var(--mag-btn, #CE3F70))"
          : "transparent",
        boxShadow: ring ? "inset 0 1px 0 rgba(255,255,255,.5)" : "none",
      }}
    >
      <span
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: "#fff",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Mark size={inner} title={title} />
      </span>
    </span>
  );
}

/** Wordmark: the mark followed by the studio name in the display face. */
export function Wordmark({ size = 26 }) {
  return (
    <span className="bar-brand">
      <Mark size={size} />
      <span className="word">D&rsquo;leaps</span>
    </span>
  );
}
